module.exports = __webpack_public_path__ + "media/images/emblems/Biasca-coat_of_arms-6b7307c862ace0fa9355e81fa6f55e90.svg";